<template lang="">
    <section class="copy" :v-if="this.getContent?.content !== undefined">
      <div class="container">
        <div class="row">
          <div v-for="item in getPageContent?.pageContent?.PCM?.WP" :key="item?.WPName" v-show="item?.WPName === 'content'">
            <div :class="item?.WPName" v-html="item?.WPC"></div>
          </div>
        </div>
      </div>

      <div class="container">
        <section class="apps">
          <div class="row">
            <div class="pe-0 col">
              <img  v-bind:src="'' + this.getContent?.content?.iosAppImageUrl" 
                class="img-fluid"
                alt="Download the Betway app for IOS"
              />
            </div>
            <div class="ps-2 pe-2 col">
              <img  v-bind:src="'' + this.getContent?.content?.androidAppImageUrl"
                class="img-fluid"
                alt="Download the Betway app for Android"
              />
            </div>
            <div class="ps-0 col">
              <img  v-bind:src="'' + this.getContent?.content?.huaweiAppImageUrl"
                class="img-fluid"
                alt="Download the Betway app for Huawei"
              />
            </div>
          </div>
        </section>
      
        <section class="sponsors">
          <div class="row">
            <div class="col">
              <img  v-bind:src="'' + this.getContent?.content?.BrightonHoveAlbionImageUrl"
                class="sponsor img-fluid d-block mx-auto"
                alt="Albion Logo"
              />
            </div>
            <div class="col">
              <img  v-bind:src="'' + this.getContent?.content?.SpringboksImageUrl"
                class="sponsor img-fluid d-block mx-auto"
                alt="Springboks Logo"
              />
            </div>
            <div class="col">
              <img  v-bind:src="'' + this.getContent?.content?.AtleticoMadridImageUrl"
                class="sponsor img-fluid d-block mx-auto"
                alt="Atletico Madrid Logo"
              />
            </div>
          </div>
        </section>
       

        <section class="banking">
          <div class="row align-items-center">
            <div class="col">
              <img  v-bind:src="'' + this.getContent?.content?.kazangBankingImageUrl"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </div>
            <div class="col">
              <img  v-bind:src="'' + this.getContent?.content?.oneForyouBankingImageUrl"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </div>
            <div class="col">
              <img  v-bind:src="'' + this.getContent?.content?.ottBankingImageUrl"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </div>
            <div class="col">
              <img  v-bind:src="'' + this.getContent?.content?.bluBankingImageUrl"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </div>
          </div>
        </section>
      </div>
    </section> 
</template>

<script>
import { store } from '../store/store.js'

export default {
  computed: {
    getContent() {
      return {
        content: {
          pageContent: store?.content?.pageContent,

          // Apps Images
          iosAppImageUrl: store?.content?.iosAppImage,
          androidAppImageUrl: store?.content?.androidAppImage,
          huaweiAppImageUrl: store?.content?.huaweiAppImage,

          //sponsors Images
          BrightonHoveAlbionImageUrl: store?.content?.BrightonHoveAlbionImage,
          SpringboksImageUrl: store?.content?.SpringboksImage,
          AtleticoMadridImageUrl: store?.content?.AtleticoMadridImage,

          //banking
          kazangBankingImageUrl: store?.content?.kazangBankingImage,
          oneForyouBankingImageUrl: store?.content?.oneForyouBankingImage,
          ottBankingImageUrl: store?.content?.ottBankingImage,
          bluBankingImageUrl: store?.content?.bluBankingImage,

        }
      }
    },
    getPageContent() {
      return {
        pageContent: store.pageContent
      };
    },
  }
};
</script>

<style scoped>
.body-content {
  font-family: inherit;
  font-size: 16px !important;
  font-weight: 400 !important;
  margin-top: 3rem;
  line-height: 1.5;
}

h1 {
  font-size: calc(1rem + 4.5vw) !important;
  font-weight: 700 !important;
}

h2 {
  font-size: calc(2rem + 0.9vw) !important;
  font-weight: 700 !important;
}

h3 {
  font-size: calc(2rem + 0.9vw) !important;
  font-weight: 700 !important;
}
</style>
